import * as toastr from "toastr";
import { RemoveLastEmotionEntryAsync } from "source/app/presentation/MainPanel/KeyValueLogs/KeyValueLogs";

export async function ClearLastEmotionEntryAsync() {
    try {
        const didRemoveEntry = await RemoveLastEmotionEntryAsync();

        if (didRemoveEntry) {
            toastr.success("Last emotion entry cleared");
        } else {
            toastr.info("No emotion entry to clear");
        }
    } catch {
        toastr.error("Unable to clear the last emotion entry");
    }
}
